import { GET_SCORES_LOADING, GET_SCORES_SUCCESS, GET_SCORES_ERROR } from "../../../constant/actionTypes";

const scoresReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_SCORES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_SCORES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case GET_SCORES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default scoresReducer;